import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormFlex } from '../FormGrid';
import { Typography } from '../Typography';
import { FileInfo } from './FileInfo';
export function FileInfoError({ file, onDelete, errors }) {
    return (_jsxs("div", { children: [_jsx(FileInfo, { file: file, onDelete: onDelete }), _jsx(FormFlex, { columnGap: 2, rowGap: 0, flexDirection: "column", children: errors.map((error, index) => (_jsx(Typography, { variant: "body2", color: "error", children: error?.message }, index))) })] }));
}
